/**
 * Reset Password Controller
 */
(function () {

    angular.module('app.reset')
        .controller('ResetController', ResetController);

    ResetController.$inject = ['authentication', 'authenticationSettings','azureSettings' ,'$rootScope', '$location', '$window'];
    function ResetController(authentication, authenticationSettings, azureSettings, $rootScope, $location, $window) {
		// get params
		var token = $location.search().resettoken;
		var redirectUrl = $location.search().redirecturl;

		// setup model data
		var vm = this;
		vm.emailAddress = $location.search().email;
		vm.resettingPassword = false;
		vm.reset = false;
		
		// setup model functions
        vm.updatePassword = updatePassword;
        var applicationCacheKey = $location.search().clientId;
        if (!applicationCacheKey) {
            // use MultiPointII by default
            applicationCacheKey = authenticationSettings.defaultApplicationCacheKey;
        }

        function updatePassword() {
            vm.resettingPassword = true;
            authentication.resetPassword({ username: vm.emailAddress, password: vm.password, token: token }).then(function (response) {
                vm.errorMessage = null;

                if (response.data === 'Password successfully updated.') {
                    vm.reset = true;
                    login();

                }
                else {
                    vm.errorMessage = response.data;
                    vm.resettingPassword = false;
                }
            }, function (err) {

                vm.errorMessage = 'Unable to reset password. Please try again.';
                vm.resettingPassword = false;
            });
        }
        vm.RedirectMfa = function () {
            window.open(authenticationSettings.helpdeskUrl);
        }
        vm.RedirectLogin = function () {
            RedirectMFALogin();
        }
        function RedirectMFALogin(){
            authentication.isUserExistInAzure(vm.emailAddress).then(function (data) {
                if (data != null & data != undefined & data != "") {
                    authentication.getNonce(vm.emailAddress).then(function (nonceResponse) {
                        var tenantName = azureSettings.tenantName;
                        var policyName = azureSettings.passwordlessPolicy;
                        var clientId = azureSettings.clientId;
                        var redirectUri = azureSettings.redirectUri;
                        var nonceData = nonceResponse.data
                        var redirect = $location.search().redirecturl || $rootScope.redirectURL;
                        var redirectUrl = redirect ? redirect.split('#')[0] : "";
                        var applicationClientId = '';
                        switch (redirectUrl.toLowerCase()) {

                            case authenticationSettings.cpoUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.cpoCacheKey;
                                break;

                            case authenticationSettings.reportingUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.reportingCacheKey;
                                break;
                            case authenticationSettings.dealerSettingsUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.dealerSettingsCacheKey;
                                break;
                            case authenticationSettings.multiPointUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.multiPointCacheKey;
                                break;
                            case authenticationSettings.shopProvisioningUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.shopProvisioningCacheKey;
                                break;
                            case authenticationSettings.packageEditorUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.packageEditorCacheKey;
                                break;
                            case authenticationSettings.avenueUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.avenueCacheKey;
                                break;
                        }
                        if (applicationClientId != '') {
                            applicationCacheKey = applicationClientId;
                        }
                        var url = "https://" + tenantName + ".b2clogin.com/" + tenantName + ".onmicrosoft.com/" + policyName + "/oauth2/v2.0/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&scope=openid&code_challenge=" + nonceData.codeChallenge + "&code_challenge_method=S256&login_hint=" + vm.emailAddress + "&nonce=" + nonceData.userNonce + "&state=" + applicationCacheKey + ";" + vm.emailAddress + ";" + nonceData.userNonce + ";" + nonceData.codeVerifier;
                        $window.location.href = url;
                    },
                        function (err) {
                            $rootScope.value = err;
                            vm.errorMessage = "MFA Validation Cancelled. Please try again.";
                        });
                }
            });
        }

        function login() {
            var authData = authentication.getAuthData;

            var request = {
                username: vm.emailAddress,
                password: vm.password,
                applicationCacheKey: authenticationSettings.defaultApplicationCacheKey
            };

			authentication.login(request).then(function (response) {
                authentication.isUserRegisteredForMFA(vm.emailAddress).then(function (mfadata) {
                    if (!mfadata) {
                        $('#mfaModal').modal('show');
                    }
                    else {
                        RedirectMFALogin();
                    }
                });
			}, function (err) {
				$location.path('/');
			});
		}
	}
})();